<template>
    <div class="sub_contents join_glass_page">
        <div class="cont_center join_glass_center">
            <div class="join_title_group">
                <p class="join_stage_badge">회원가입 STEP 2</p>
                <h2 class="title_page">회원 가입</h2>
            </div>
            <div class="login_box_area join_glass_card">
                <!-- <h3 class="title_login">Hi-Vitamin<br>Membership</h3> -->
                <div class="login_input_area">
                    <p class="join_descript">회원정보를 입력해 주세요.</p>
                    <ul class="login_input_list">
                        <li>
                            <h3 class="title_input">아이디</h3>
                            <div class="id_input_areae">
                                <InputText id="memberId" :placeholder="placeholderId" @input="isAlphaNumeric" />
                                <button class="btn_type1" @click="checkId">중복확인</button>
                            </div>
                            <p v-if="idError" class="error-message">영어와 숫자만 입력 가능합니다.</p>
                        </li>
                        <li>
                            <h3 class="title_input">비밀번호</h3>
                            <InputText type="password" id="password" :placeholder="placeholderPw"
                                @input="validatePasswordInput" />
                            <p v-if="passwordError" class="error-message">숫자, 영문, 특수문자를 2가지 이상 조합해 8~16자리로 생성해주세요.</p>
                        </li>
                        <li>
                            <h3 class="title_input">비밀번호 확인</h3>
                            <InputText type="password" id="passwordRe" :placeholder="placeholderPwCk" />
                            <p v-if="passwordMismatch" class="error-message">비밀번호가 일치하지 않습니다.</p>
                        </li>
                        <li>
                            <h3 class="title_input">이름</h3>
                            <InputText id="memberName" />
                        </li>
                        <li>
                            <h3 class="title_input">생년월일</h3>
                            <div class="birth_select_area">
                                <SelectBox :optionName="selectY" :items="yearList" dropdownId="yearList"
                                    @itemSelected="onchangeYearValue" /> 년
                                <SelectBox :optionName="selectM" :items="monthList" dropdownId="monthList"
                                    @itemSelected="onchangeMonthValue" /> 월
                                <SelectBox :optionName="selectD" :items="dayList" dropdownId="dayList"
                                    @itemSelected="onchangeDayValue" /> 일
                            </div>
                        </li>
                        <li>
                            <h3 class="title_input">이메일</h3>
                            <div class="email_area">
                                <InputText id="email1" @input="validateEmailInput" /> @
                                <InputText id="email2" @input="validateEmailInput" />
                                <SelectBox :optionName="selectmail" :items="emailList" dropdownId="emailList"
                                    @itemSelected="handleEmailDomainSelected" />
                            </div>
                            <p v-if="emailError" class="error-message">유효한 이메일 주소를 입력해주세요.</p>
                        </li>
                        <li class="no_required">
                            <div class="gender_select_area">
                                <RadioBox v-for="option in genderOption" :key="option.value" :id="option.value"
                                    :name="radioGroupName" :value="option.value" :label="option.label"
                                    v-model="selectedOption" />
                            </div>
                        </li>
                    </ul>
                    <div class="btn_login_area">
                        <a href="#" to="/HFO_MB_005" class="btn_type2 disabled" @click.prevent="handleJoin">확인</a>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <AlertPopup v-model="alertRequiredShow" title="알림">
        <template #layer_content>
            <p class="alert_txt" id="alert_txt">{{ alertContent }}</p>
        </template>
    </AlertPopup>
</template>

<script>
import InputText from '@/components/InputText';
import SelectBox from '@/components/SelectBox';
import RadioBox from '@/components/RadioBox';
import AlertPopup from '@/components/AlertPopup.vue';
import { onMounted, ref } from 'vue';
import { postAxios, getAxios } from '@/lib/AxiosCall';
import { getPlatformInfo } from '@/lib/Config';
import { useRoute, useRouter } from 'vue-router';

export default {
    components: {
        InputText,
        SelectBox,
        RadioBox,
        AlertPopup
    },
    data() {
        return {
            placeholderId: '영문, 숫자로 입력',
            placeholderPw: '영문, 숫자, 특수문자 8~16자 이내 입력',
            placeholderPwCk: '확인을 위해 한번 더 입력해 주세요.',
            selectY: '선택',
            selectM: '선택',
            selectD: '선택',
            selectedY: '',
            selectedM: '',
            selectedD: '',
            genderOption: [
                { label: '남자', value: 'M', checked: false },
                { label: '여자', value: 'F', checked: false }
            ],
            radioGroupName: 'gender',
            selectmail: '직접 입력',
            emailList: [
                { name: 'naver.com', value: 'naver.com' },
                { name: 'daum.net', value: 'daum.net' },
                { name: 'google.com', value: 'google.com' }
            ],
            alertRequiredShow: false,
            idCheck: 'N',
            idError: false,
            passwordError: false,
            passwordMismatch: false,
            emailError: false,
            alertContent: ''
        };
    },
    setup() {
        const selectedOption = ref('X');
        const route = useRoute();
        const router = useRouter();
        const userData = JSON.parse(sessionStorage.getItem('userData'));

        const yearList = ref([]);
        const monthList = ref([]);
        const dayList = ref([]);

        onMounted(() => {
            for (let year = 2005; year >= 1950; year--) {
                yearList.value.push({ name: year, value: year });
            }
            for (let month = 1; month <= 12; month++) {
                monthList.value.push({ name: month < 10 ? `0${month}` : month, value: month });
            }
            for (let day = 1; day <= 31; day++) {
                dayList.value.push({ name: day < 10 ? `0${day}` : day, value: day });
            }
        });

        return {
            userData,
            route,
            router,
            yearList,
            monthList,
            dayList,
            selectedOption
        };
    },
    methods: {
        redirectToCpsTargetIfExists() {
            try {
                const raw = sessionStorage.getItem('cps_entry_context') || localStorage.getItem('cps_entry_context');
                const cpsContext = raw ? JSON.parse(raw) : null;
                const targetUrl = cpsContext?.targetUrl || (typeof this.route?.query?.targetUrl === 'string' ? this.route.query.targetUrl : '');
                if (!targetUrl) return false;

                let finalUrl = targetUrl;
                const ci = cpsContext?.ci || (typeof this.route?.query?.ci === 'string' ? this.route.query.ci : '');
                if (ci) {
                    try {
                        const parsed = new URL(finalUrl);
                        parsed.searchParams.set('ci', ci);
                        finalUrl = parsed.toString();
                    } catch (_e) {
                        // ignore malformed URL and fallback to original
                    }
                }

                try {
                    if (window && window.opener && !window.opener.closed) {
                        window.opener.location.href = finalUrl;
                        sessionStorage.removeItem('cps_entry_context');
                        localStorage.removeItem('cps_entry_context');
                        window.close();
                        return true;
                    }
                } catch (_e) {
                    // opener 접근 실패 시 현재 창 이동으로 폴백
                }

                sessionStorage.removeItem('cps_entry_context');
                localStorage.removeItem('cps_entry_context');
                window.location.href = finalUrl;
                return true;
            } catch (_e) {
                return false;
            }
        },

        async handleJoin() {
            if (!this.validateForm()) return;

            try {
                let platformUser = '';
                let platformGroup = '';
                try {
                    const q = this.route?.query || {};
                    const cpsRaw = sessionStorage.getItem('cps_entry_context') || localStorage.getItem('cps_entry_context');
                    const cps = cpsRaw ? JSON.parse(cpsRaw) : {};
                    const platform = getPlatformInfo();

                    // 광고 embed 값 매핑: data-hvm-user-id -> platformUser, data-hvm-sub-id -> platformGroup
                    platformUser = String(q.platformUser || q.userId || cps.userId || platform.platformUser || '').trim();
                    platformGroup = String(q.platformGroup || q.subId || cps.subId || platform.platformGroup || '').trim();
                } catch (_e) {
                    platformUser = '';
                    platformGroup = '';
                }

                const payload = {
                    id: document.querySelector("#memberId").value,
                    password: document.querySelector("#password").value,
                    name: document.querySelector("#memberName").value,
                    birth: `${this.selectedY}-${this.selectedM}-${this.selectedD}`,
                    gender: this.genderValues,
                    email: `${document.querySelector("#email1").value}@${document.querySelector("#email2").value}`,
                    agreementYn: this.termsChecked,
                    privacyYn: this.privacyChecked,
                    commerceYn: this.ecommChecked,
                    emailYn: this.emailChecked,
                    smsYn: this.smsChecked,
                    sttsType: "USER_MEMBER",
                    inType: 'USER_IN_NORMAL'
                };

                if (platformUser) payload.platformUser = platformUser;
                if (platformGroup) payload.platformGroup = platformGroup;

                const response = await postAxios('/bgm/v1/mem/member', payload);

                console.log("response", response);

                sessionStorage.setItem('termsChecked', false);
                sessionStorage.setItem('privacyChecked', false);
                sessionStorage.setItem('ecommChecked', false);
                sessionStorage.setItem('emailChecked', false);
                sessionStorage.setItem('smsChecked', false);

                if (this.redirectToCpsTargetIfExists()) {
                    return;
                }

                const redirect = this.route.query.redirect || '/HFO_MB_005';
                this.router.push({ path: redirect });
            } catch (error) {
                console.error('회원 가입 중 오류가 발생했습니다:', error);
            }
        },
        validateForm() {
            if (document.querySelector("#memberId").value === '') {
                this.alertContent = 'ID를 입력해 주세요';
                this.alertRequiredShow = true;
                return false;
            }
            if (this.idCheck === 'N') {
                this.alertContent = 'ID 중복 확인을 해주세요';
                this.alertRequiredShow = true;
                return false;
            }
            if (document.querySelector("#password").value === '') {
                this.alertContent = '패스워드를 입력해 주세요';
                this.alertRequiredShow = true;
                return false;
            }
            if (document.querySelector("#passwordRe").value === '') {
                this.alertContent = '패스워드 확인을 입력해 주세요';
                this.alertRequiredShow = true;
                return false;
            }
            if (document.querySelector("#password").value !== document.querySelector("#passwordRe").value) {
                this.alertContent = '패스워드가 일치하지 않습니다';
                this.alertRequiredShow = true;
                return false;
            }
            if (!this.validatePassword()) {
                this.alertContent = '패스워드 규칙이 맞지 않습니다';
                this.alertRequiredShow = true;
                return false;
            }
            if (document.querySelector("#memberName").value === '') {
                this.alertContent = '이름을 입력해 주세요';
                this.alertRequiredShow = true;
                return false;
            }
            if (this.selectedY === '' || this.selectedY === '선택') {
                this.alertContent = '태어난 연도를 입력해 주세요';
                this.alertRequiredShow = true;
                return false;
            }
            if (this.selectedM === '' || this.selectedM === '선택') {
                this.alertContent = '태어난 월을 입력해 주세요';
                this.alertRequiredShow = true;
                return false;
            }
            if (this.selectedD === '' || this.selectedD === '선택') {
                this.alertContent = '태어난 일자를 입력해 주세요';
                this.alertRequiredShow = true;
                return false;
            }
            if (document.querySelector("#email1").value === '') {
                this.alertContent = '이메일 주소를 입력해 주세요';
                this.alertRequiredShow = true;
                return false;
            }
            if (document.querySelector("#email2").value === '') {
                this.alertContent = '이메일 도메인을 입력해 주세요';
                this.alertRequiredShow = true;
                return false;
            }
            if (this.selectedOption === 'X') {
                this.alertContent = '성별을 선택해 주세요';
                this.alertRequiredShow = true;
                return false;
            }
            return true;
        },
        isAlphaNumeric() {
            const inputId = document.querySelector("#memberId").value;
            const alphaNumericPattern = /^[a-zA-Z0-9]+$/;
            if (!alphaNumericPattern.test(inputId)) {
                this.alertContent = '영어와 숫자만 입력 가능합니다';
                this.alertRequiredShow = true;
                document.querySelector("#memberId").value = inputId.replace(/[^a-zA-Z0-9]/g, '');
                this.idCheck = 'N';
            }
        },
        validatePassword() {
            const password = document.querySelector("#password").value;
            const pwdPattern = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[!@#$%^&*()])[a-zA-Z\d!@#$%^&*()]{8,16}$/;
            return pwdPattern.test(password);
        },
        validateEmail(email) {
            const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            return emailRegex.test(email);
        },
        async checkId() {
            const response = await getAxios('/bgm/v1/search/id', {
                userId: document.querySelector("#memberId").value
            });
            if (response.id !== '') {
                this.alertContent = '이미 사용중인 ID 입니다';
                this.alertRequiredShow = true;
            } else {
                this.alertContent = '사용 가능한 ID 입니다';
                this.alertRequiredShow = true;
                this.idCheck = 'Y';
            }
        },
        onchangeYearValue(selectedValue) {

            this.selectedY = selectedValue;
            console.log(this.selectedY); // 선택된 값 출력
        },
        onchangeMonthValue(selectedValue) {

            this.selectedM = selectedValue;
            console.log(this.selectedM); //

        },
        onchangeDayValue(selectedValue) {

            this.selectedD = selectedValue;
            console.log(this.selectedD); //

        },
        handleEmailDomainSelected(selectedValue) {
            console.log('Selected email domain:', selectedValue); // 선택된 값 출력
            // 여기서 필요한 추가 작업을 처리할 수 있습니다.
            var element1 = document.querySelector("#email2");
            element1.value = selectedValue;
            //this.emailDomain = selectedValue;
        },
    }
};
</script>

<style>
.error-message {
    color: red;
    font-size: 12px;
    margin-top: 5px;
}
</style>

<style scoped>
.join_title_group {
    margin-bottom: 12px;
}

.join_stage_badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin: 0 0 8px;
    padding: 4px 12px;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.02em;
    color: #7a5600;
    background: #ffefc2;
}

@media (min-width: 1024px) {
    .join_glass_page {
        position: relative;
        overflow: hidden;
        background:
            radial-gradient(circle at 14% 18%, rgba(255, 195, 52, 0.22), transparent 32%),
            radial-gradient(circle at 84% 78%, rgba(238, 117, 40, 0.12), transparent 38%),
            linear-gradient(180deg, #fffaf0 0%, #f8f8f8 100%);
    }

    .join_glass_page::before {
        content: "";
        position: absolute;
        inset: 0;
        background-image:
            linear-gradient(rgba(255, 255, 255, 0.14) 1px, transparent 1px),
            linear-gradient(90deg, rgba(255, 255, 255, 0.14) 1px, transparent 1px);
        background-size: 28px 28px;
        pointer-events: none;
        z-index: 0;
    }

    .join_glass_center {
        position: relative;
        z-index: 1;
        max-width: 980px;
        margin: 0 auto;
        padding: 24px 20px 36px;
    }

    .join_glass_card {
        border-radius: 22px;
        border: 1px solid rgba(255, 255, 255, 0.8);
        background: linear-gradient(145deg, rgba(255, 255, 255, 0.88), rgba(255, 255, 255, 0.72));
        box-shadow: 0 24px 54px rgba(0, 0, 0, 0.1);
        backdrop-filter: blur(8px);
    }

    .join_glass_center :deep(.title_page) {
        margin-bottom: 10px;
    }
}
</style>